<template></template>

<script>
export default {
  name: "HelpIA",
  props: {},
  data() {
    return {};
  },
  mounted() {
    const jQueryScript = document.createElement("script");
    jQueryScript.setAttribute(
      "src",
      "https://code.jquery.com/jquery-3.7.1.min.js",
    );
    document.body.appendChild(jQueryScript);

    const inlineScript = document.createElement("script");
    inlineScript.append(`
        bot_id = '685';
        bot_token = '186zz700ci';
        bot_server_type = 'production';
      `);
    document.body.appendChild(inlineScript);

    const inbotScript = document.createElement("script");
    inbotScript.setAttribute(
      "src",
      "https://bot-server.s3.amazonaws.com/api/inbot.gz.js",
    );
    inbotScript.setAttribute("id", "chatscript");
    document.body.appendChild(inbotScript);
  },
};
</script>

<style>
#bot_icon {
  width: 60px !important;
}
#powered_by_bot {
  display: none;
}
</style>
